import { IState } from "../types";
import {
  activateGambitReducer,
  changeGambitReducer,
  swapGambitsReducer,
  updateGambitReducer
} from "./gambitReducers";
import turnReducer from "./turnReducer";
import boardReducer from "./boardReducers";
import { IReducerAction } from "./types";

function screenReducer(state: IState, action: IReducerAction): IState {
  if (!action.payload) return state;
  if (!("screen" in action.payload)) return state;
  return { ...state, screen: action.payload.screen };
}
// eslint-disable-next-line complexity
function rootReducer(state: IState, action: IReducerAction): IState {
  switch (action.type) {
    case "changeTurn": {
      return turnReducer(state);
    }
    case "swapGambits": {
      return swapGambitsReducer(state, action);
    }
    case "activateGambit": {
      return activateGambitReducer(state, action);
    }
    case "updateGambit":
      return updateGambitReducer(state, action);
    case "changeGambit":
      return changeGambitReducer(state, action);
    case "board/spendPoints":
      return boardReducer(state, action);
    case "screen/changeScreen":
      return screenReducer(state, action);
    default: {
      return state;
    }
  }
}

export default rootReducer;
